import type { UsTerritoryConfig } from '@dnc/baseline/contentful/types';
import { type Territory } from '@dnc/baseline/data/jurisdictions';

import { Services } from '../services/services';
import { UrlHelper } from '../services/url-helper';

/**
 * Helper for loading a {@link JurisdictionConfig} from Contentful. Uses the URL
 * to determine if we’re doing a test config or preview data.
 *
 * Throws if the loading failed.
 */
export async function fetchUsTerritoryConfig(
  services: Pick<Services, 'voterEducation'>,
  urlHelper: UrlHelper,
  jurisdiction: Territory
): Promise<UsTerritoryConfig> {
  const contentfulParams = urlHelper.parseContentfulParams();

  const territoryConfig = await services.voterEducation.fetchUsTerritoryConfig(
    jurisdiction,
    !!contentfulParams.preview,
    !!contentfulParams.test_config
  );

  if (!territoryConfig) {
    throw new Error(`Failure loading territory: ${jurisdiction}`);
  }

  return territoryConfig;
}
